const START_UP = 'startup';
const STARTUP_PLUS = 'startup-plus';
const START_SUITE = 'startup-suite';
const ONLINE_STARTUP = 'online-startup';
const RELOCATION_STARTUP = 'relocation-startup';
export const REGISTRATION_TYPE = Object.freeze({
    START_UP,
    STARTUP_PLUS,
    START_SUITE,
    ONLINE_STARTUP,
    RELOCATION_STARTUP,
    TYPES: [
        START_UP,
        STARTUP_PLUS,
        START_SUITE,
        ONLINE_STARTUP,
        RELOCATION_STARTUP, 
    ]
});

export const NRIC_CITIZEN_ID = 1;
export const NRIC_PERMANENT_RESIDENT = 2;

export const SINGAPORE_CITIZEN = "SINGAPORE CITIZEN";

/* eslint-disable import/prefer-default-export */
export const COMPANY = Object.freeze({
    REGISTER_TYPE_TRANSFER_COMPANY      : 'Transfer',
    REGISTER_TYPE_INCORPORATION_COMPANY : 'Incorporation',

    STATUS_ACTIVE                       : 'Active',
    STATUS_PENDING                      : 'Pending',
    STATUS_INACTIVE                     : 'In Active',
    STATUS_IN_PROGRESS                  : 'In Progress',
    STATUS_INCORPORATED                 : 'Incorporated',
    STATUS_PRE_INCORPORATED             : 'Pre Incorporated',
    STATUS_INCORPORATION_ERROR          : 'Incorporation Failure',
    STATUS_PRE_INCORPORATION_ERROR      : 'Pre Incorporation Failure',
    STATUS_TRANSFER_COMPANY_IN_PROGRESS : 'Transfer In Progress',
    STATUS_TRANSFER_FAILURE             : 'Transfer Failure',

    REMARK_GENERATED_PRE_INCORPORATION_DOCUMENTS  : 'Generated pre incorporation documents',
    GENERATED_TRANSFER_COMPANY_REMARK             : 'Generated transfer documents',
    FINISHED_TRANSFER_COMPANY_REMARK              : 'Finished transfer',
    
    DIRECTOR: {
        STATUS_ACTIVE: 'Active',
        STATUS_RESIGNED: 'Resigned',
        REQUEST_TYPE_APPOINT: 'appoint',
        REQUEST_TYPE_RESIGN: 'resign',
    },

    SHAREHOLDER: {
        STATUS_ACTIVE: 'Active',
        STATUS_CANCELLED: 'Cancelled'
    },

    NATURE: {
        ALLOTMENT : 'Allotment',
        TRANSFER_IN: 'Transfer In',
        TRANSFER_OUT: 'Transfer Out',
        SHARE_CANCELLATION: 'Share Reduction',
    },

    SHARE_CERTIFICATE: {
        STATUS: {
            CANCELLED: 'Cancelled',
            ACTIVE: 'Active',
            INACTIVE: 'Inactive',
        },
        FOLIO_FORM_GOOGLE_APP_SCRIPT: 'GAS',
    },

    MIGRATION_FORMAT: {
        ACTIVE_ONLY: 'active-only',
        ALL: 'all'
    }
});

export const PREPARE_DOCUMENTS = Object.freeze({
    ANNUAL_RETURN : {
        DORMANT_FORM : 'Dormant Form',
    },
    AGM : 'AGM Form',
    AGM_DISPENSATION_FORM : 'AGM Dispensation Form',
    ALLOTMENT_FORM : 'Allotment Form',
    STRIKE_OFF : 'Strike Off',
    DIRECTOR_RESOLUTIONS: {
        CHANGE_FYE_FORM: 'Change of FYE Form',
        DIRECTOR_FEE_FORM: 'Director Fee Form',
        CHANGE_DIRECTOR_FORM: 'Change Director Form',
        CHANGE_DIRECTOR_NOMINATOR_FORM: "Change Director's Nominator Form",
        CHANGE_SHAREHOLDER_NOMINATOR_FORM: "Change Shareholder's Nominator Form",
        CHANGE_RO_FORM: 'Change RO Form',
        CHANGE_AUDITOR_FORM: 'Change Auditor Form',
        SALE_OF_PROPERTY_WITH_OPTION_FORM: 'With Option Form',
        SECRETARY_RESIGNATION_FORM: 'Secretary Resignation Form',
        DATA_PROTECTION_OFFICER_FORM: 'Data Protection Officer Form',
    },
    
    BUSINESS_ACTIVITIES: {
        'CHANGE_SECONDARY_ACTIVITY_FORM': 'ΔII', 
        'CHANGE_PRIMARY_ACTIVITY_FORM': 'ΔI',
        'CHANGE_PRIMARY_AND_SECONDARY_ACTIVITY_FORM': 'ΔI ΔII',
        'CHANGE_PRIMARY_AND_ADD_SECONDARY_ACTIVITY_FORM': 'ΔI +II', 
        'REMOVE_SECONDARY_ACTIVITY_FORM': '-II', 
        'CHANGE_PRIMARY_AND_REMOVE_SECONDARY_ACTIVITY_FORM': 'ΔI -II', 
        'ADD_SECONDARY_ACTIVITY_FORM': '+II'
    },
    TRANSFER_FORM: 'Transfer Form',
    INTERIM_DIVIDEND_FORM: 'Interim Dividend Form',
    SHARE_CANCELLATION_FORM: 'Share Reduction Form',
    SHARE_BUY_BACK_FORM: 'Share Buy Back Form',
    PARTICULARS_OF_DIRECTOR_FORM: 'Particulars of Director Form',
    PARTICULARS_OF_SHAREHOLDER_FORM: 'Particulars of Shareholder Form',
    CAPITAL_PAYMENT_FORM: 'Update Paid Up Capital Form',
    CHANGE_OF_COMPANY_NAME_FORM: 'Change of Company Name Form',

    STATUS: {
        STATUS_IN_PROGRESS       : 'In Progress',
        STATUS_GENERATED         : 'Generated',
        STATUS_GENERATION_FAILURE: 'Generation Failure',
        STATUS_CANCELLED: 'Cancelled',
        AUTHORISATION_TYPE       : 'authorisation_type',
    }
});

export const SHARE_REDUCED_STATUS = Object.freeze({
    PENDING: 'pending',
    APPROVED: 'approved'
});

export const FEE = Object.freeze({
    NOMINEE_DIRECTOR_SERVICE: 'Nominee Director Service',
    RELOCATION_SERVICE: 'Relocation Service',
    ADDITIONAL_SHAREHOLDER_FEE: 'Additional shareholder fee',
    SECRETARY_FEE: 'Secretary fee'
});

export const COMPANY_INFORMATION = Object.freeze({
    DEFAULT_COMPANY_DOMAIN: 'PTE. LTD.'
});

export const COMPANY_ADDRESS = Object.freeze({
    GOLD_PLAN      : 'GOLD',
    PLATINUM_PLAN  : 'PLATINUM',
    OWN_ADDRESS    : 'Own Address',
    ENSTON_ADDRESS : 'Enston Address',
});

export const DIRECTORS_AND_SHAREHOLDERS = Object.freeze({
    DIRECTOR_NAME : 'director',
    ENSTON_DIRECTOR_NAME: 'Enston Nominee Director'
});

export const SECRETARIES = Object.freeze({
    SECRETARY_NAME : 'secretary',
});

export const TICKET = Object.freeze({
    OPEN: 'Open',
    CLOSE: 'Closed'
});

export const SHAREHOLDER = Object.freeze({
    TYPE: {
        INDIVIDUAL: 'individual',
        CORPORATE: 'corporate'
    }
});

export const CHARGE = Object.freeze({
    CHARGEE_TYPE: {
        INDIVIDUAL: 'individual',
        CORPORATE: 'corporate'
    },

    CHARGE_INSTRUMENT_EXECUTED: {
        IN_SINGAPORE: 'In Singapore',
        OUTSIDE_SINGAPORE: 'Outside Singapore'
    }
});

export const NOMINEE_DIRECTOR = Object.freeze({
    NOMINATOR: {
        TYPE: {
            INDIVIDUAL: 'individual',
            CORPORATE: 'corporate'
        }
    }
});

export const NOMINEE_SHAREHOLDER = Object.freeze({
    NOMINATOR: {
        TYPE: {
            INDIVIDUAL: 'individual',
            CORPORATE: 'corporate'
        }
    }
});

export const MAS_LIST = Object.freeze({
    STATUS_IMPORTING: 'Importing',
    STATUS_IMPORTED: 'Imported',
    STATUS_EXCEPTION_OCCURRED: 'Exception Occurred',
});

export const SETTING = Object.freeze({
    LEVEL  : 'level',
    LEVEL_0: 'NO_PAYMENT',
    LEVEL_1: 'FINISHED_PAYMENT',
    LEVEL_2: 'FINISHED_ONBOARDING',
});

export const DIRECTOR_INTEREST = Object.freeze({
    HOW_HELD: {
        HOW_HELD_HOLDER_OPTIONS         : 'In own name',
        HOW_HELD_SPOUSE_NOMINEE_OPTIONS : "In Spouse/Nominee's Name",
        HOW_HELD_NAME_OF_BODIES_OPTIONS : 'In Name of Bodies Corporate'
    },
    TYPES: {
        TYPE_OWN_COMPANY               : 'INTEREST IN COMPANY',
        TYPE_HOLDING_COMPANY           : "INTEREST IN COMPANY'S HOLDING COMPANY",
        TYPE_ULTIMATE_HOLDING_COMPANY  : "INTEREST IN COMPANY'S ULTIMATE HOLDING COMPANY",
        TYPE_SUBSIDIARY_COMPANY        : "INTEREST IN COMPANY'S SUBSIDIARY",
        TYPE_SUBSIDIARY_HOLDING_COMPANY: "INTEREST IN SUBSIDIARY OF COMPANY'S HOLDING COMPANY"
    }
});

export const COMMON_SEAL_TYPES = Object.freeze({
    WITH: 'With',
    WITHOUT: 'Without'
});

// FILES
export const FILE = Object.freeze({
    UPLOAD_LIMIT: '25MB'
});

// DOWNLOADS
export const DOWNLOAD = Object.freeze({
    STATUS_SUBMITTED : "Submitted",
    STATUS_EXPIRED   : "Expired",
    STATUS_COMPLETED : "Completed",
    STATUS_ERROR     : "Error",
});

// GENERAL
export const EMPTY = undefined;
export const DRIVE_FILE_TYPE = 'file';
export const DRIVE_FOLDER_TYPE = 'dir';
export const PDF_MIME_TYPE = 'application/pdf';
export const GOOGLE_DOC_MIME_TYPE = 'application/vnd.google-apps.document';

export const DOCUMENT = Object.freeze({
    TYPE: 'file',
    FOLDER_TYPE: 'dir',
    PDF_MIME_TYPE: "pdf",
    GOOGLE_DOC_MIME_TYPE: "vnd.google-apps.document",
    SIGNATURE: {
        STATUS_COMPLETED: 'Completed',
        STATUS_NOT_COMPLETED: 'Not Completed',
    },
    SIGNED_SIGNATURE_STATUS       : 'Signed Signatures',
    PENDING_SIGNATURE_STATUS      : 'Pending Signatures',
    PENDING_YOUR_SIGNATURE_STATUS : 'Pending Your Signatures',
    PENDING_OTHER_SIGNATURE_STATUS: 'Pending Other Signatures',
    REVIEW_DOCUMENTS_STATUS: 'Review',
    STATUES: {
        DRAFT: 'draft',
        SENT: 'sent',
        PENDING: 'pending',
        COMPLETED: 'completed',
        PHYSICALLY_SIGNED: 'physically signed',
        DROPBOX_SIGNED: 'dropbox signed',
        MARK_AS_SIGNED: 'mark as signed',
        CANCELLED: 'Cancelled'
    }
});

export const PROCESS = Object.freeze({
    PRE_INCORPORATION : 'Pre Incorporation',
    INCORPORATION : 'Incorporation',
    SECRETARY_APPOINTMENT : 'Secretary Appointment',
    SECRETARY_RESIGNATION: 'Secretary Resignation',
    CHANGE_OF_FYE: 'Change of FYE',
    DIRECTOR_FEE: 'Director Fee',
    CHANGE_DIRECTOR: 'Change Director',
    CHANGE_NOMINATOR: 'Change Nominator',
    CHANGE_AUDITOR: 'Change Auditor',
    CHANGE_RO: 'Change RO',
    ANNUAL_RETURN : 'Annual Return',
    AGM : 'AGM',
    AGM_DISPENSATION : 'AGM Dispensation',
    ALLOTMENT : 'Allotment',
    STRIKE_OFF : 'Strike Off',
    BUSINESS_ACTIVITIES: 'Business Activities',
    TRANSFER: 'Transfer',
    INTERIM_DIVIDEND: 'Interim Dividend',
    SHARE_CANCELLATION: 'Share Reduction',
    SHARE_BUY_BACK: 'Share Buy Back',
    UPDATE_OF_PARTICULARS: 'Update of Particulars',
    SALE_OF_PROPERTY: 'Sale of Property',
    CAPITAL_PAYMENT: 'Update Paid Up Capital',
    DATA_PROTECTION_OFFICER: 'Data Protection Officer',
    CHANGE_OF_COMPANY_NAME: 'Change of Company Name',
});

export const REGISTER_DOCUMENT = Object.freeze({
    PROCESS: "Register",

    TYPES : {
        'SECRETARIES': 'secretaries',
        'CEO': "CEO",
        'DIRECTORS': 'directors',
        'AUDITORS': 'auditors',
        'ALLOTMENTS': 'allotments',
        'MEMBERS': 'members',
        'DIRECTOR_INTERESTS': "director interests",
        'NOMINEE_DIRECTORS': "nominee directors",
        'NOMINEE_SHAREHOLDERS': "nominee shareholders",
        'CONTROLLERS': "controllers",
        'CHARGES': "charges",
        'TRANSFERS': "transfers",
    }
});

export const CLIENTS = Object.freeze({
    STATUS_SENT : 'sent',
    STATUS_UNSENT : 'unsent',
});

export const CHANGE_OF_TYPES = Object.freeze({
    NAME                : 'Name',
    EMAIL               : 'Email Address',
    PASSPORT            : 'Passport Number',
    CONTACT             : 'Contact Number',
    ADDRESS             : 'Residential Address',
    ALTERNATIVE_ADDRESS : 'Alternative Address',
});

export const DIRECTOR_TITLE_OPTIONS = Object.freeze([
    'Mr', 
    'Mrs', 
    'Ms',
    'Dr'
]);

export const AUTHORIZED_INDIVIDUAL_TYPE_OPTIONS = Object.freeze({
    SINGLE  : 'SINGLY',
    ANY_TWO : 'ANY TWO',
    ANY     : 'ANY'
});


/*
|--------------------------------------------------------------------------
| < CONFIGURATION >
|--------------------------------------------------------------------------
*/
export const DATE_PICKER_CONFIG = Object.freeze({
    altFormat: "j M Y",
    dateFormat: "j M Y",
});

export const SLIDER_CONFIG = Object.freeze({
    value: 45,
    step: 10,
    range: [
        {
            label: "0%",
        },
        {
            label: "5%",
            isHide: true,
        },
        {
            label: "10%",
        },
        {
            label: "15%",
            isHide: true,
        },
        {
            label: "20%",
        },
        {
            label: "25%",
            isHide: true,
        },
        {
            label: "30%",
        },
        {
            label: "35%",
            isHide: true,
        },
        {
            label: "40%",
        },
        {
            label: "45%",
            isHide: true,
        },
        {
            label: "50%",
        },
        {
            label: "55%",
            isHide: true,
        },
        {
            label: "60%",
        },
        {
            label: "65%",
            isHide: true,
        },
        {
            label: "70%",
        },
        {
            label: "75%",
            isHide: true,
        },
        {
            label: "80%",
        },
        {
            label: "85%",
            isHide: true,
        },
        {
            label: "90%",
        },
        {
            label: "95%",
            isHide: true,
        },
        {
            label: "100%",
        },
    ],

    processStyle: {
        backgroundColor: "#4267B2",
    },

    tooltipStyles: {
        backgroundColor: "#4267B2",
        borderColor: "#4267B2",
    },
});

// TABLES
export const TABLE = Object.freeze({
    PER_PAGE: 10,
    PER_PAGE_OPTIONS: [10, 25, 50, 100] 
});

export const TEMPLATE_FILES = Object.freeze({
    APPLICATION_FOR_SHARES_FORM: 'Application for shares form',
    RISK_ASSESSMENT: 'Risk Assessment',
    BENEFICIAL_OWNER_DECLARATION: 'Beneficial Owner Declaration',
    NOMINEE_DIRECTOR_AGREEMENT: 'Nominee Director Agreement',
    SHARE_CERTIFICATE: 'Share Certificate',
    CORPORATE_SECRETARY_AGREEMENT: 'Corporate Secretary Agreement',
    CONSENT_TO_ACT_AS_DIRECTOR: 'Consent to act as director',
    POA: 'POA',
    FORM_24: 'Form 24',
    NOTICE: 'Notice',
    MINUTES: 'Minutes',
    DIRECTOR_RESOLUTION: 'Director Resolution',
    ACRA_LATTER: 'ACRA Latter',
    SOLVENCY_STATEMENT: 'Solvency Statement',
    SHAREHOLDER_RESOLUTION: 'Shareholder Resolution',
});

export const SOW_AND_SOF_TOOLTIP_INFO = Object.freeze([
    {
        otherSourceId: 7,
        uniqueId: "7T1",
        label: 'Please provide one of the following if ‘Yes’.',
        option: [
            "Latest financial statement from which the shareholder generated wealth",
            "Latest business tax return",
            "Business registration document with shareholder details"
        ],
    },
    {
        otherSourceId: 8,
        uniqueId: "8T1",
        label: 'Please provide a copy of the loan agreement if ‘Yes’.',
        option: [],
    },
    {
        otherSourceId: 9,
        uniqueId: "9T1",
        label: 'Please provide one of the following if ‘Yes’.',
        option: [
            "Latest Tax Returns",
            "Latest salary slip",
            "Letter of employment in company’s letters (less than 3 months old) "
        ],
    },
    {
        otherSourceId: 10,
        uniqueId: "10T1",
        label: 'Please provide a copy of the loan agreement if ‘Yes’.',
        option: [],
    },
    {
        otherSourceId: 11,
        uniqueId: "11T1",
        label: 'Please provide one of the following if ‘Yes’.',
        option: [
            "Grant of Letter of Administration with Will",
            "Grant of Probate with Schedule of Assets",
        ],
    },
    {
        otherSourceId: 12,
        uniqueId: "12T1",
        label: 'Please provide a copy of the loan agreement if ‘Yes’.',
        option: [],
    },
    {
        otherSourceId: 13,
        uniqueId: "13T1",
        label: 'Please provide one of the following if ‘Yes’.',
        option: [
            "Latest income tax return",
            "A copy of your bank statement that is less than 3 months old",
        ],
    },
    {
        otherSourceId: 14,
        uniqueId: "14T1",
        label: "Please provide a copy of the sale and purchase agreement if ‘Yes’.",
        option: [],
    }
]);

/*
|--------------------------------------------------------------------------
| </ CONFIGURATION >
|--------------------------------------------------------------------------
*/

export const SIGNATURES = Object.freeze({
    TYPED: 'typed',
    DREW: 'drew',
    UPLOADED: 'uploaded'
});